import { SchedulerSettingsTabs } from '@lp/features/Scheduler/components';
import { CCSchedulerSettingsInputsTab, CCSchedulerSettingsRulesTab } from './components';

export const SchedulerClinicalCoordinatorsSettings = () => {
  return (
    <SchedulerSettingsTabs inputsTab={<CCSchedulerSettingsInputsTab />} rulesTab={<CCSchedulerSettingsRulesTab />} />
  );
};
